import * as React from 'react';

import {MarketingBody} from '../typography/marketing-body';
import {MarketingTitle} from '../typography/marketing-title';

import styles from './empty-state-popover.module.css';

type Props = {
    title: string;
    subtitle: string;
    cta?: React.ReactNode;
};

export function EmptyStatePopover(props: Props) {
    return (
        <div className={styles.container}>
            <div className={styles['empty-text']}>
                <MarketingTitle>{props.title}</MarketingTitle>
                <MarketingBody>{props.subtitle}</MarketingBody>
            </div>
            {props.cta}
        </div>
    );
}
